import { makeStyles } from '@material-ui/core';

export const useProductStyles = makeStyles(({ spacing }) => ({
  filtersHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: `1px solid #e0e0e0`,
    height: 55,
    paddingBottom: spacing(1)
  },
  filterConteiner: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
  dialogPaper: {
    width: '95%',
    height: '95%',
    maxHeight: '95% !important',
    maxWidth: '95% !important',
    borderRadius: 24
  }
}));
